module.exports = __webpack_public_path__ + "img/qrcode.374a6102.jpg";